/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.VisitNoteTypes {
    "use strict";

    export class VisitNoteTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        fileTypesEnum = Meevo.Model.FileTypes;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.visitNoteType;
            this.sectionTemplatePath = "app/plugins/visitNoteTypes/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.DATA_VISITNOTETYPE_TAB_MAIN);
            this.entityType = 'VisitNoteType';
        }

        initializeSections(): void {
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_VISITNOTETYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_VISIT_NOTE_TYPE_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.visitNoteType, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.VisitNoteTypeMain, null, this.securityKeys.DATA_VISITNOTETYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }
        get showCopy(): boolean {
            return false;
        }
        get canCopy(): boolean {
            return false;
        }

        protected MAX_TEXT_LENGTH: number = 10000;
        save(): angular.IPromise<any> {
            let model = this.castModel<Model.VisitNoteType>();
            if (model && model.templateText && model.templateText.length > this.MAX_TEXT_LENGTH) {
                let msg = this.$translate.instant("MESSAGE_VISIT_NOTE_TYPE_TEMPLATE_OVER_LIMIT", { visitNoteTypeTemplateLimit: "10k" });
                return this.modalService.alert(msg);
            }
            return super.save();
        }

    }
}
